<div
  data-testid="box-text"
  [className]="classDiv + ' inline-flex'"
  (click)="clickAction()">
  <ps-icon
    *ngIf="icon"
    [iconClass]="iconClass"
    [iconColor]="iconColor"
    [iconSize]="iconSize"
    [srcIcon]="icon">
  </ps-icon>
  <span *ngIf="!toolText" [innerHTML]="text" [className]="classText"></span>
  <span
    *ngIf="!!toolText"
    #tooltip="matTooltip"
    [matTooltipPosition]="'right'"
    [matTooltip]="toolText"
    [className]="classToolText">
    {{ text }}
  </span>
</div>
